import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
} from '@angular/core';

// TODO: these directives have some strange behavior. still need to be debugged

@Directive({
  selector: '[deepFocusIn]',
})
export class DeepFocusInDirective {
  @Output() deepFocusIn = new EventEmitter();

  constructor(private readonly el: ElementRef) {}

  @HostListener('document:focusin', ['$event'])
  click($event: FocusEvent) {
    if (!this.el.nativeElement.contains($event.relatedTarget)) {
      this.deepFocusIn.emit();
    }
  }
}

@Directive({
  selector: '[deepFocusOut]',
})
export class DeepFocusOutDirective {
  @Output() deepFocusOut = new EventEmitter();

  constructor(private readonly el: ElementRef) {}

  @HostListener('document:focusout', ['$event'])
  click($event: FocusEvent) {
    if (!this.el.nativeElement.contains($event.relatedTarget)) {
      this.deepFocusOut.emit();
    }
  }
}
